
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 20C65 20 20 65 20 120s45 100 100 100 100-45 100-100S175 20 120 20zm0 191.5c-50.5 0-91.5-41-91.5-91.5s41-91.5 91.5-91.5 91.5 41 91.5 91.5-41 91.5-91.5 91.5zm-.847-164.749c6.266.071 12.681 3.161 16.071 8.316.045.069.086.141.129.211l24.341 42.159 25.022 43.475s1.248 3.263 1.428 6.125c.61 9.721-6.729 19.289-16.789 20.977 0 0-.36.068-.891.088l-48.984.068-49.947-.068s-2.728-.338-4.877-1.16c-9.357-3.581-15.146-14.675-11.865-24.825.133-.412.294-.817.494-1.207l24.509-42.587 24.853-43.046s.958-1.395 2.124-2.576c3.75-3.8 9.051-5.97 14.382-5.95zm-.243 8.499c-3.486.04-6.876 1.736-9.015 4.481l-.016.02a71310.65 71310.65 0 00-49.016 85.033c-.041.128-.079.256-.116.385-1.686 6.17 2.453 13.218 9.095 14.427l.036.006c32.741.045 65.488.046 98.241.001 6.299-1.057 11.072-8.015 9.048-14.725l-.029-.093a73383.73 73383.73 0 00-49.016-85.033c-2.165-2.827-5.602-4.515-9.212-4.502zm5.112 87.71c0-2.759-2.24-5-5-5-2.759 0-5 2.241-5 5 0 2.76 2.241 5 5 5 2.76 0 5-2.24 5-5zm0-61c0-2.759-2.24-5-5-5-2.759 0-5 2.241-5 5v43c0 2.76 2.241 5 5 5 2.76 0 5-2.24 5-5v-43z","fill-rule":"nonzero"}})])
          )
        }
      }
    